import React, { useMemo } from 'react';
import ConfigurationProvider from './service/Provider';
import ModelListFiltersUI from './ModelListFilters';
import isSSR from '../../utils/isSSR';
import useAppName from '../../utils/sitecoreContext/useAppName';
import { ACURA_SITE_NAME, HONDA_SITE_NAME, MARINE_SITE_NAME, PE_SITE_NAME, PSP_SITE_NAME } from '../../utils/constants';
import { variant1, variant2, variant3, variant4 } from './service/constants';
const ModelListFiltersMap = ({ rendering, ...props }) => {
    var _a, _b, _c, _d, _e, _f, _g;
    /** this component is part of /vehicles page, which is quite heavy.
     * One of the optimization is to remove ModelListFilters component
     * from App nodes tree for SSR to optimize app capacity.
     */
    const appName = useAppName();
    let categoryFilterLabel = '';
    let variant;
    let filterTypes = ((_c = (_b = (_a = props === null || props === void 0 ? void 0 : props.fields) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.value) === null || _c === void 0 ? void 0 : _c.filterType) || [];
    const singleSelectFilters = filterTypes === null || filterTypes === void 0 ? void 0 : filterTypes.filter(item => { var _a, _b; return ((_b = (_a = item === null || item === void 0 ? void 0 : item.enableSingleSelect) === null || _a === void 0 ? void 0 : _a.item) === null || _b === void 0 ? void 0 : _b.value) === true; }).map(item => item.filterCategory.fields.name);
    switch (appName) {
        case HONDA_SITE_NAME:
        case ACURA_SITE_NAME:
            variant = variant1;
            break;
        case MARINE_SITE_NAME:
            variant = variant2;
            break;
        case PSP_SITE_NAME:
            variant = variant3;
            break;
        case PE_SITE_NAME:
            categoryFilterLabel =
                ((_g = (_f = (_e = (_d = filterTypes === null || filterTypes === void 0 ? void 0 : filterTypes.find(item => item.filterCategory.fields.name === 'productType')) === null || _d === void 0 ? void 0 : _d.filterCategory) === null || _e === void 0 ? void 0 : _e.fields) === null || _f === void 0 ? void 0 : _f.filterCategoryName) === null || _g === void 0 ? void 0 : _g.value) || '';
            filterTypes = filterTypes.filter(item => item.filterCategory.fields.name !== 'productType');
            variant = variant4;
            break;
        default:
    }
    const appNameConfig = useMemo(() => ({ variant, filterTypes, categoryFilterLabel, singleSelectFilters }), [variant, filterTypes, categoryFilterLabel, singleSelectFilters]);
    if (isSSR()) {
        return null;
    }
    return (React.createElement(ConfigurationProvider, { appNameConfig: appNameConfig },
        React.createElement(ModelListFiltersUI, { componentName: rendering === null || rendering === void 0 ? void 0 : rendering.componentName, ...props })));
};
export default ModelListFiltersMap;
